var map = {
	"./en-GB": "60ca",
	"./en-GB.json": "60ca",
	"./fr-BE": "6cb8",
	"./fr-BE.json": "6cb8",
	"./nl-BE": "8823",
	"./nl-BE.json": "8823"
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(function() {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__.t(id, 3);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5892";
module.exports = webpackAsyncContext;